import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, onyxLight, onyxLighter, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  initializingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: white,
  },
  modalOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999999,
  },
  modalContent: {
    backgroundColor: white,
    padding: indent * 1.5,
    borderRadius: 12,
    width: '90%',
    maxWidth: 400,
    alignItems: 'center',
    shadowColor: black,
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 10,
  },
  modalTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: indent * 0.75,
    color: black,
    textAlign: 'center',
  },
  modalDescription: {
    fontSize: 16,
    color: onyxLight,
    textAlign: 'center',
    marginBottom: indent * 1.25,
    lineHeight: 24,
  },
  countdownText: {
    fontWeight: 'bold',
    color: black,
  },
  modalButton: {
    backgroundColor: black,
    paddingVertical: 14,
    paddingHorizontal: indent * 2,
    borderRadius: 8,
    width: '100%',
    height: 50, // Fixed height to prevent jump when spinner appears
    justifyContent: 'center',
  },
  modalButtonDisabled: {
    backgroundColor: onyxLighter,
  },
  modalButtonText: {
    color: white,
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
  logoutLink: {
    marginTop: indent * 0.75,
    paddingVertical: 10,
  },
  logoutLinkText: {
    color: onyxLighter,
    fontSize: 14,
    textDecorationLine: 'underline',
    fontWeight: '500',
  },
});
